import { Helmet } from 'react-helmet-async';

const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_nsec-refresh/artifacts/nnzc6d20_IMG_1445.JPG';

export const Seo = ({
  title,
  description,
  image = DEFAULT_IMAGE,
  path = '',
}) => {
  const fullTitle = title ? `${title} — NSEC Ltd` : 'NSEC Ltd';
  const desc = description || "Professional, reliable and sustainable service solutions. From environmental services and commercial collections to highways and driver training, we're your local partner in protecting the environment.";
  const url = `https://hr-portal-dev-4.emergent.host${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="NSEC Ltd" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
